import ControlCupboardArtIcon from './component'

export default ControlCupboardArtIcon
